<div class="main-container">
  <section class="top-section">
    <go-back
      class="on-mobil"
      [routerLink]="['/authentication/forgot-password']"
    ></go-back>
    <cp-logo></cp-logo>
  </section>
  <section class="back-home-section">
    <go-back
      class="desktop"
      [routerLink]="['/authentication/forgot-password']"
    ></go-back>
  </section>

  <div class="flow-container" [formGroup]="form">
    <div class="reset-password-code-container">
      <section class="set-code-container">
        <h1>Reset password code</h1>
        <h3>Insert the verification code you received in your email.</h3>
        <label for="">Code</label>
        <ng-otp-input
          (onInputChange)="onOtpChange($event)"
          #ngOtpInput
          [config]="{ length: 6 }"
        ></ng-otp-input>
        <p for="">
          Didn’t received a code?&nbsp;
          <ng-template [ngIf]="(resendEmailLoading$ | async) ?? false">
            <mat-spinner [diameter]="20" class="mat-spinner-green">
            </mat-spinner>
          </ng-template>
          <ng-template
            [ngIf]="!(resendEmailLoading$ | async)"
            [ngOutletContext]="context"
          >
            <span (click)="sendAgain()">Send Again</span>
          </ng-template>
        </p>
      </section>
    </div>
    <div class="new-password-container">
      <section class="new-password-container">
        <h1>New Password</h1>
        <label for="">New Password</label>
        <gbui-input
          formControlName="password"
          password
          [ngClass]="{
            'invalid-input':
              !form.controls['password'].valid &&
              form.controls['password'].touched
          }"
          placeholder="Enter your new password"
        ></gbui-input>
        <label
          class="scale-up-ver-top"
          *ngIf="
            !form.controls['password'].valid &&
            form.controls['password'].touched
          "
        >
          {{ getPasswordErrorMessage('password') }}
        </label>
        <br />
        <label for="">Confirm New Password</label>
        <gbui-input
          formControlName="confirmPassword"
          password
          [ngClass]="{
            'invalid-input':
              !form.controls['confirmPassword'].valid &&
              form.controls['confirmPassword'].touched
          }"
          placeholder="Enter your new password"
        ></gbui-input>
        <label
          class="scale-up-ver-top"
          *ngIf="
            !form.controls['confirmPassword'].valid &&
            form.controls['confirmPassword'].touched
          "
        >
          {{ getPasswordErrorMessage('confirmPassword') }}
        </label>
        <gbui-button
          [disabled]="form.invalid"
          (click)="changePassword()"
          class="buttons-outline"
          type="submit"
          [busy]="resetPasswordLoading$ | async"
          >Save</gbui-button
        >
      </section>
    </div>
  </div>
  <div class="flow-container"></div>
</div>
